<template>
    <!-- Mypage Menu -->
    <div class="p-nav__mypage mypage-nav">
        <div class="mypage-menu mypage-nav__inner">
            <!-- user -->
            <div class="mypage-menu__user">
                <div class="user__icon">
                    <button class="user__image">
                        <img src="@/assets/img/ate_img/dummy_user.jpg" alt="User Icon" />
                    </button>
                </div>
                <div class="user__name">{{ (sessionStore.session_data['last_name'] && !userStore.isOverseasUser ? sessionStore.session_data['last_name'] : "") + (sessionStore.session_data['first_name'] ? sessionStore.session_data['first_name'] : "") }}<span>さん</span></div>
                <div class="user__account">{{ sessionStore.session_data['email'] ?? "" }}</div>
            </div>
            <ul class="mypage-menu__list">
                <li><a href="/user-profile"><span class="icon"><img src="@/assets/img/ui_parts/svg/menu_icon_account.svg"
                                :alt="$t('LABEL_ACCOUNT_SETTINGS')" /></span>{{ $t('LABEL_ACCOUNT_SETTINGS') }}</a></li>
                <li>
                  <router-link :to="{ name: 'shipping.addresses' }">
                    <span class="icon"><img src="@/assets/img/ui_parts/svg/menu_icon_shipping.svg" :alt="$t('LABEL_DELIVERY_ADDRESS_SETTINGS')" /></span>{{ $t('LABEL_DELIVERY_ADDRESS_SETTINGS') }}
                  </router-link>
                </li>
                <!-- <li>
                    <router-link :to="{ name: 'credit.cards' }">
                        <span class="icon"><img src="@/assets/img/ui_parts/svg/menu_icon_payment.svg" :alt="$t('LABEL_PAYMENT_SETTINGS')" /></span>{{ $t('LABEL_PAYMENT_SETTINGS') }}
                    </router-link>
                </li> -->
                <li>
                    <router-link :to="{ name: 'merchant.list' }" id="link-merchant-list">
                        <span class="icon"><img src="@/assets/img/ui_parts/svg/menu_icon_merchant.svg" :alt="$t('LABEL_USED_MERCHANT')" /></span>{{ $t('LABEL_USED_MERCHANT') }}
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'transaction.history' }" id=link-transaction-history>
                        <span class="icon"><img src="@/assets/img/ui_parts/svg/menu_icon_transaction.svg" :alt="$t('LABEL_TRANSACTION_HISTORY')" /></span>{{ $t('LABEL_TRANSACTION_HISTORY') }}
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'contact.us' }">
                        <span class="icon"><img src="@/assets/img/ui_parts/svg/menu_icon_contact.svg" :alt="$t('LABEL_CONTACT_US')" /></span>{{ $t('LABEL_CONTACT_US') }}
                    </router-link>
                </li>
                <li><a href="#" @click.prevent="logOut" id=nav-logout><span class="icon"><img src="@/assets/img/ui_parts/svg/menu_icon_logout.svg"
                                :alt="$t('LABEL_LOGOUT')"/></span>{{ $t('LABEL_LOGOUT') }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { useSessionStore } from "@/stores/sessionStore";
import { useUserStore } from "@/stores/userStore";
import { onMounted } from "vue";
import router from "@/router";
import { initializeMain } from "@/assets/js/entries/main.js";

const sessionStore = useSessionStore();
const userStore = useUserStore();

async function logOut() {
    if (await sessionStore.logOut()) {
        router.push({ name: "login" });
    }
    else {
        router.push({ name: "error" });
    }
}

onMounted(async () => {
    if( userStore.isOverseasUser === null ) {
        await userStore.getAccountInfo();
    }
    
    initializeMain();
})
</script>